import React from 'react';

export default function InfoBox({children, type, className = '', template = 'default'}) {

    const typeIcon = (type) => {
        switch (type) {
            case 'warning':
                return (
                    <svg className="w-4 h-4 shrink-0 fill-current text-amber-500" viewBox="0 0 16 16">
                        <path
                            d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z"/>
                    </svg>
                );
            case 'error':
                return (
                    <svg className="w-4 h-4 shrink-0 fill-current text-rose-500" viewBox="0 0 16 16">
                        <path
                            d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z"/>
                    </svg>
                );
            case 'success':
                return (
                    <svg className="w-4 h-4 shrink-0 fill-current text-emerald-500" viewBox="0 0 16 16">
                        <path
                            d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z"/>
                    </svg>
                );
            default:
                return (
                    <svg className="w-4 h-4 shrink-0 fill-current text-indigo-500" viewBox="0 0 16 16">
                        <path
                            d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"/>
                    </svg>
                );
        }
    };

    const themeStyle = (template) => {
        switch (template) {
            case 'inline':
                return (
                    'inline-flex flex-col w-full text-xs text-slate-500 items-center pt-[3px]'
                );
            default:
                return (
                    'inline-flex flex-col w-full max-w-lg rounded-sm text-sm bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-400 ' +
                    'px-4 py-2 shadow-lg border border-slate-200 dark:border-slate-700'
                );
        }
    };

    return (
            <div
                className={`${className} ${themeStyle(template)}`}
                role="alert"
            >
                <div className="flex w-full justify-between items-start">
                    <div className="flex gap-3 items-center">
                        {typeIcon(type)}
                        <div>{children}</div>
                    </div>
                </div>
            </div>
    );
}
